module.exports = __webpack_public_path__ + "static/media/Sensei.64897a19.svg";